export function productRequestError(error: any, fallback: string): string {
  if (error?.response?.status === 401 || error?.response?.status === 403) {
    return "판매자 권한을 확인할 수 없습니다. 판매자 계정으로 다시 로그인해주세요.";
  }
  const message = error?.response?.data?.message;
  if (Array.isArray(message)) return message.join(" ");
  if (typeof message === "string" && message.trim()) return message;
  return error instanceof Error && !error.name.includes("Axios") ? error.message : fallback;
}
